import { BreadcrumbDefinition, MainLayout } from '@components/Layout';
import { HeaderText } from '@components/Layout/HeaderText';
import { Typography } from '@mui/material';
import { useReducer } from 'react';
import { CampaignDataGrid } from '../components/CampaignDataGrid';
import { Filters } from '../components/Filters';
import { reducer } from '../stores/reducer';
import { initialState } from '../domain/filter';
import { FilterContext } from '../stores/filter-context';

type CampaignListProps = {
  breadcrumbs: BreadcrumbDefinition[];
};

export const CampaignList = (props: CampaignListProps) => {
  const [filterState, dispatch] = useReducer(reducer, initialState);

  return (
    <MainLayout breadcrumbs={props.breadcrumbs}>
      <HeaderText>Campaign List</HeaderText>
      <Typography>
        All your Media Measurement campaigns in one place!
      </Typography>
      <FilterContext.Provider value={{ filterState, dispatch }}>
        <Filters />
        <CampaignDataGrid />
      </FilterContext.Provider>
    </MainLayout>
  );
};
